import * as IState from '../classes/IState'
import * as IFrontendTheme from '../classes/ProjectMgmt/IFrontendTheme'
import * as Button from "./_CustomComponents/CustomButtonComponent";
import ColumnLeft from './_AppStructure/ColumnLeft';
import packageJSON from '../../package.json'; // assert {type: 'json'}; // https://bobbyhadz.com/blog/get-version-from-package-json-in-node-js-code

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Environment
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const AppVersion: string = 'v' + packageJSON.version;

export function IsDevEnv(): boolean {
    return (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') ? true : false;
}
export function IsNonProductionEnv(): boolean {
    return (IsDevEnv() || window.location.hostname.includes('test.generativ.site') === true) ? true : false;
}
export function IsOnAzure(): boolean {
    return (window.location.hostname.includes('generativ.site') === true ? true : false);
}
export function IsAzureProdEnv(): boolean {
    return IsOnAzure() && !IsNonProductionEnv();
}

export const AppHeaderLiteral: string = IsNonProductionEnv() === true ? 'Generativ.' : 'Generativ.';
export const AppDocumentTitle: string = IsDevEnv() ? "G (LOCAL)" : IsAzureProdEnv() ? "Generativ" : "G (TEST)";

export const key_StaryKolarz: string = "BC1YLgweyjvkZVNcC2FRrHj5Lz11oJ861U2BnmKXP77Krz6C26nds6b";
export const key_Celestoid: string = "BC1YLgYmxwTbjUhiqQk1ad4brLyYP4FgnNT8Yf2naYTL8Ty3XeMqQq7";


//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// DeSo API
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const DefaultMinFeeRateNanosPerKB: number = 1000;
export const DerivedKeySigningMinFeeRateNanosPerKB: number = 1700;

export const DeSoAPIURL_NodeDeSoOrg: string = "https://node.deso.org/";
export const DeSoAPIURL_BitcloutCom: string = "https://bitclout.com/";
export const DeSoAPIURL_DeSocialWorld: string = "https://desocialworld.com/"
export const DeSoAPIURL_NodeDeSoOrg_APIv0: string = DeSoAPIURL_NodeDeSoOrg + "api/v0/";
export const DeSoAPIURL_DeSocialWorld_APIv0: string = DeSoAPIURL_DeSocialWorld + "api/v0/";

export const DeSoAPI_GetSingleProfilePicture: string = DeSoAPIURL_NodeDeSoOrg_APIv0 + "get-single-profile-picture/";


//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Generativ API
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

function GetSessionKeyKeyString(PK: string, SeriesUuid: string | undefined = undefined): string {
    const SessionKeyKeyBase:string = 'SessionKey';
    if (!IsPublicKeyValid(PK))
    {
        return "";
    }
    if (SeriesUuid === undefined)
    {
        return SessionKeyKeyBase + '_' + PK;
    }
    if (!IsGuidValid(SeriesUuid))
    {
        return "";
    }
    return SessionKeyKeyBase + '_' + PK + '_' + SeriesUuid;
}
export function StoreUserSessionKey(key: string, PK: string) {
    localStorage.setItem(GetSessionKeyKeyString(PK), key);
}
export function StoreCreatorInSeriesSessionKey(key: string, PK: string, SeriesUuid: string) {
    localStorage.setItem(GetSessionKeyKeyString(PK, SeriesUuid), key);
}
export function GetUserSessionKey(PK: string): string | null {
    return localStorage.getItem(GetSessionKeyKeyString(PK));
}
export function GetCreatorInSeriesSessionKey(PK: string, SeriesUuid: string): string | null {
    return localStorage.getItem(GetSessionKeyKeyString(PK, SeriesUuid));
}

export const GenerativAPIURL: string = IsDevEnv() ? "https://192.168.20.219:5001/" : IsAzureProdEnv() ? "https://generativeweb.azurewebsites.net/" : "https://generativewebtest.azurewebsites.net/";

// Merge Minting
export const GenerativAPIURL_MergeMintConfirmMergeMinting: string = GenerativAPIURL + "MergeMintConfirmMergeMinting";
export const GenerativAPIURL_MergeMintGetBestMatches: string = GenerativAPIURL + "MergeMintGetBestMatches";
export const GenerativAPIURL_MergeMintGetInProgressSourceNFTsForUser: string = GenerativAPIURL + "MergeMintGetInProgressSourceNFTsForUser";
export const GenerativAPIURL_MergeMintGetMergedProposal: string = GenerativAPIURL + "MergeMintGetMergedProposal";
export const GenerativAPIURL_MergeMintGetTraitProbabilities: string = GenerativAPIURL + "MergeMintGetTraitProbabilities";
export const GenerativAPIURL_MergeMintTransferSourceNFT: string = GenerativAPIURL + "MergeMintTransferSourceNFT";

// Mint Pass
export const GenerativAPIURL_MintPassAdd: string = GenerativAPIURL + "MintPassAdd";
export const GenerativAPIURL_MintPassGetMintPasses: string = GenerativAPIURL + "MintPassGetMintPasses";

// NFT Item Ops
export const GenerativAPIURL_GetNFTImage: string = GenerativAPIURL + "GetNFTImage";
export const GenerativAPIURL_NFTItemConfirmForMinting: string = GenerativAPIURL + "NFTItemConfirmForMinting";
export const GenerativAPIURL_NFTItemList: string = GenerativAPIURL + "NFTItemList";
export const GenerativAPIURL_NFTItemListForUser: string = GenerativAPIURL + "NFTItemListForUser";
export const GenerativAPIURL_NFTItemMintInitial: string = GenerativAPIURL + "NFTItemMintInitial";
export const GenerativAPIURL_NFTItemSkipAndRegenerate: string = GenerativAPIURL + "NFTItemSkipAndRegenerate";

// Project Mgmt
export const GenerativAPIURL_GetBanner: string = GenerativAPIURL + "GetBanner";
export const GenerativAPIURL_Metadata:string = GenerativAPIURL + "Metadata";
export const GenerativAPIURL_ProjectList: string = GenerativAPIURL + "ProjectList";
export const GenerativAPIURL_SeriesMgmt: string = GenerativAPIURL + "SeriesMgmt";

// Security
export const GenerativAPIURL_AuthorizeDerivedKey: string = GenerativAPIURL + "AuthorizeDerivedKey";
export const GenerativAPIURL_CheckCreateUser: string = GenerativAPIURL + "CheckCreateUser";


//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Exception handling consts
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export function GetErrorMessage(e: any): string {
    if (typeof e.message === 'string')
        return e.message;
    else
        return 'Error message undefined.';
}


//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Guid consts & helpers
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export const GuidDefault: string = "00000000-0000-0000-0000-000000000000";
export function IsGuidValid(PotentialGuid: string | undefined): boolean {
    const PotentialGuidSplitted:string[] | undefined = PotentialGuid?.split('-');
    return PotentialGuid !== undefined && PotentialGuid !== null && PotentialGuid !== '' && PotentialGuid !== GuidDefault && PotentialGuid.length === GuidDefault.length && PotentialGuidSplitted?.length === 5;
}


//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Date consts & helpers
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export const EpochTime: Date = new Date(Date.UTC(1970, 0, 1, 0, 0, 0, 0));
export const ServerTimezoneOffset: number = IsOnAzure() ? 0 : (new Date()).getTimezoneOffset();

export function FromServerToClientZoneSafeDate(InDate: Date): Date {
    return new Date(
        new Date(InDate).getUTCFullYear(), new Date(InDate).getUTCMonth(), new Date(InDate).getUTCDate(),
        new Date(InDate).getUTCHours(), new Date(InDate).getUTCMinutes() - ServerTimezoneOffset, new Date(InDate).getUTCSeconds()
      )
}
export function FormatClientZoneSafeDate(InDate: Date, EpochTimeText: string = ''): string {
    if (InDate === undefined || InDate === null || FromServerToClientZoneSafeDate(InDate) <= EpochTime)
      return EpochTimeText;
    else
      return new Intl.DateTimeFormat(('en-gb'), { weekday:'short', year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit', }).format(FromServerToClientZoneSafeDate(InDate)) + ' UTC';
  }
  

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// DeSo related Validators
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export const DeSoPublicKeyPrefix = 'BC1Y';
export function IsPublicKeyValid(PotentialPK: string | undefined): boolean {
    return PotentialPK !== undefined && PotentialPK !== null && PotentialPK !== '' && PotentialPK.length === 55 && PotentialPK?.substring(0, 4) === DeSoPublicKeyPrefix;
}
export function IsPostHashHexValid(PotentialPostHashHex: string | undefined): boolean {
    return PotentialPostHashHex !== undefined && PotentialPostHashHex !== null && PotentialPostHashHex !== '' && PotentialPostHashHex.length === 64;
}


//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// App consts
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const NanosInDeso:number = 1000000000;

export const CustomEvent_StateChange:string = 'CustomEvent_StateChange';

export const BodyMode_ProjectNFTList:string = 'ProjectNFTList';
export const BodyMode_Mint:string = 'Mint';
export const BodyMode_Mate:string = 'Mate';
export const BodyMode_UserNFTList:string = 'UserNFTList';
export const BodyMode_Landing:string = 'Landing';


//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// State management utils
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export function CloneState({props}: IState.IState): IState.IState {
    const Clonedstate: IState.IState = { props };
    return JSON.parse(JSON.stringify(Clonedstate));
}


//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// utils - separate someday
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export function gConsoleLog(logString: String): void {
    if (IsNonProductionEnv())
    {
        if (logString.toLowerCase().includes('error'))
        {
            console.error(logString);
        }
        else
        {
            console.log(logString);
        }
    }
    else
    {
        //console.log(logString); // only include logging on PROD when debugging needed
    }
}

export function gConsoleLogEx(message: any, logFullStack: boolean = false) {
    // https://stackoverflow.com/questions/38435450/get-current-function-name-in-strict-mode
    // https://stackoverflow.com/questions/1013239/can-i-get-the-name-of-the-currently-running-function-in-javascript

    if (IsNonProductionEnv())
    {
        const stack: string | undefined = new Error().stack;
        if(stack !== undefined)
        {
            if(logFullStack === true)
            {
                console.log(stack);
            }

            const caller: string = stack.split('\n')[2].trim().replace('at ', '');

            if (message.toLowerCase().includes('error'))
            {
                console.error(caller + ": " + message);
            }
            else
            {
                console.log(caller + ": " + message);
            }
        }
        else
        {
            console.error('Stack undefined; message: ' + message);
        }
    }
    else
    {
        //console.log(logString); // only include logging on PROD when debugging needed
    }
}


export const gotoLanding = async (state: IState.IState) => {
    gConsoleLog('gotoLanding');
    setGenericTheme(state.props.DefaultFrontendTheme);
    const UpdatedState: IState.IState = CloneState(state);
    UpdatedState.props.BodyMode = BodyMode_Landing;
    UpdatedState.props.IsLeftSlidingMenuBarVisible = false;
    UpdatedState.props.ProjectDisplayList = undefined;
    UpdatedState.props.NFTListSeriesSelected = undefined;
    UpdatedState.props.NFTItemGridDisplayList = undefined;
    UpdatedState.props.NFTItemInProcessing = undefined;
    UpdatedState.props.CreatorMintPassDisplayList = undefined;
    UpdatedState.props.UserMintPassDisplayList = undefined;
    UpdatedState.props.InfoMessage = undefined;
    UpdatedState.props.NFTMergeMintDictAllForUser_Left = undefined;
    UpdatedState.props.NFTMergeMintDictAllForUser_Right = undefined;
    UpdatedState.props.NFTMergeMintDictAllForUser_Merged = undefined;
    window.dispatchEvent(new CustomEvent(CustomEvent_StateChange, { detail: JSON.stringify(UpdatedState) }));
  }

export const mintNFT = (state: IState.IState) => {
    const UpdatedState: IState.IState = CloneState(state);
    UpdatedState.props.BodyMode = BodyMode_Mint;
    UpdatedState.props.IsLeftSlidingMenuBarVisible = false;
    UpdatedState.props.NFTItemGridDisplayList = undefined;
    UpdatedState.props.CreatorMintPassDisplayList = undefined;
    UpdatedState.props.InfoMessage = undefined;
    UpdatedState.props.NFTMergeMintDictAllForUser_Left = undefined;
    UpdatedState.props.NFTMergeMintDictAllForUser_Right = undefined;
    UpdatedState.props.NFTMergeMintDictAllForUser_Merged = undefined;
    window.dispatchEvent(new CustomEvent(CustomEvent_StateChange, { detail: JSON.stringify(UpdatedState) }));
  }


 export const getDeSocialWorldNFTLink = (PostHashHexOrFullURL: string, LinkText: string): JSX.Element => {
    if (PostHashHexOrFullURL.includes('https://desocialworld.com/nft/'))
    {
        return <a href={PostHashHexOrFullURL} target='_blank' rel="noopener noreferrer">{LinkText}</a>;
    }
    else
    {
        return <a href={'https://desocialworld.com/nft/' + PostHashHexOrFullURL} target='_blank' rel="noopener noreferrer">{LinkText}</a>;
    }
}
export const getOctoPosseNFTzNFTLink = (PostHashHexOrFullURL: string, LinkText: string): JSX.Element => {
    if (PostHashHexOrFullURL.includes('https://desocialworld.com/nft/'))
    {
        const PostHashHexOrFullURLClean: string = PostHashHexOrFullURL.replace('https://desocialworld.com/nft/','');
        return <a href={'https://octoposse.nftz.me/nft/' + PostHashHexOrFullURLClean} target='_blank' rel="noopener noreferrer">{LinkText}</a>;
    }
    else
    {
        return <a href={'https://octoposse.nftz.me/nft/' + PostHashHexOrFullURL} target='_blank' rel="noopener noreferrer">{LinkText}</a>;
    }
}
export const getDeSocialWorldNFTLinkAsString = (PostHashHexOrFullURL: string, LinkText: string): string => {
    if (PostHashHexOrFullURL.includes('https://desocialworld.com/nft/'))
    {
        return '<a href=\'' + PostHashHexOrFullURL + '\' target=\'_blank\' rel="noopener noreferrer">' + LinkText + '</a>';
    }
    else
    {
        return '<a href=\'https://desocialworld.com/nft/' + PostHashHexOrFullURL + '\' target=\'_blank\' rel="noopener noreferrer">' + LinkText  + '</a>';
    }
}
export const getDeSocialWorldProfileLink = (ProfileUsername: string): JSX.Element => {
    return <a href={'https://desocialworld.com/u/' + ProfileUsername} target='_blank' rel="noopener noreferrer">@{ProfileUsername}</a>;
}
export const getPostHashHexFromPostUrl = (PostUrl: string): string => {
    const PostUrlElem: string[] = PostUrl.split('/');
    return PostUrlElem[4];
}
export function delay(ms: number) {
    return new Promise( resolve => setTimeout(resolve, ms) );
}


//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// InfoMessage utils - separate someday 
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export const setInfoMessage = (state: IState.IState, InfoMsg:string) => {
    const UpdatedState: IState.IState = CloneState(state);
    UpdatedState.props.InfoMessage = InfoMsg;
    window.dispatchEvent(new CustomEvent(CustomEvent_StateChange, { detail: JSON.stringify(UpdatedState) }));
}

export const showInfoMessage = (state: IState.IState) => {
    //gConsoleLog('DFConsts.showInfoMessage: ' + state.props.InfoMessage);
    if (state.props.InfoMessage === undefined)
    {
      return null;
    }
    else if (state.props.InfoMessage === state.props.NFTItemInProcessing?.uuid)
    {
      return null;
    }
    else if (IsGuidValid(state.props.InfoMessage))
    {
      return null;
    }
    else
    {
      if (state.props.InfoMessage.toLowerCase().includes('error') || state.props.InfoMessage.toLowerCase().includes('failed'))
      {
        return <div className="infomessageerror" >
              {state.props.InfoMessage}&nbsp;&nbsp;
              <Button.Button id="info_message_close_button" border="1px solid" color="#9f2020" height = "calc(16px + 2vmin)" onClick={() => { closeInfoMessage(state); }} width = "calc(60px + 2vmin)" children = "Close" />
              </div>;
      }
      else
      {
      return <div className="infomessage" >
              {state.props.InfoMessage}&nbsp;&nbsp;
              <Button.Button id="info_message_close_button" border="1px solid" color="#206111" height = "calc(16px + 2vmin)" onClick={() => { closeInfoMessage(state); }} width = "calc(60px + 2vmin)" children = "Close" />
              </div>;
      }
    }
  }

export const closeInfoMessage = (state: IState.IState) => {
    gConsoleLog('closeInfoMessage: ' + state.props.InfoMessage);
    const UpdatedState: IState.IState = CloneState(state);
    UpdatedState.props.InfoMessage = undefined;
    window.dispatchEvent(new CustomEvent(CustomEvent_StateChange, { detail: JSON.stringify(UpdatedState) }));
  }


//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Sliding left menu - separate someday 
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export const getSlidingLeftMenuBar = (state: IState.IState) => {
    //gConsoleLog('getSlidingLeftMenuBar.');
    if (state.props.IsLeftSlidingMenuBarVisible === true)
    {
        return <div id="sliding_left_menu_bar" className="slidingleftmenubar" >
            <ColumnLeft props={state.props} />
        </div>;
    }
    else
    {
        return <div></div>
    }
}
export const showSlidingLeftMenuBar = (state: IState.IState) => {
    //gConsoleLog('showSlidingLeftMenuBar.');
    const UpdatedState: IState.IState = CloneState(state);
    UpdatedState.props.IsLeftSlidingMenuBarVisible = true;
    window.dispatchEvent(new CustomEvent(CustomEvent_StateChange, { detail: JSON.stringify(UpdatedState) }));
}
export const hideSlidingLeftMenuBar = (state: IState.IState) => {
    //gConsoleLog('hideSlidingLeftMenuBar.');
    const UpdatedState: IState.IState = CloneState(state);
    UpdatedState.props.IsLeftSlidingMenuBarVisible = false;
    window.dispatchEvent(new CustomEvent(CustomEvent_StateChange, { detail: JSON.stringify(UpdatedState) }));
}


//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// BusyIndicator utils - separate someday 
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const showBusyIndicator = (state: IState.IState) => {
    const ShowBusyIndicatorStateChange: IState.IState = CloneState(state);
    ShowBusyIndicatorStateChange.props.ShowBusyIndicator = true;
    window.dispatchEvent(new CustomEvent(CustomEvent_StateChange, { detail: JSON.stringify(ShowBusyIndicatorStateChange) }));
}

export const hideBusyIndicator = (state: IState.IState) => {
    const ShowBusyIndicatorStateChange: IState.IState = CloneState(state);
    ShowBusyIndicatorStateChange.props.ShowBusyIndicator = false;
    window.dispatchEvent(new CustomEvent(CustomEvent_StateChange, { detail: JSON.stringify(ShowBusyIndicatorStateChange) }));
}


//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// TextArea display creator
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/*const URLRegExp: RegExp = /^[a-z](?:[-a-z0-9\+\.])*:(?:\/\/(?:(?:%[0-9a-f][0-9a-f]|[-a-z0-9\._~\x{A0}-\x{D7FF}\x{F900}-\x{FDCF}\x{FDF0}-\x{FFEF}\x{10000}-\x{1FFFD}\x{20000}-\x{2FFFD}\x{30000}-\x{3FFFD}\x{40000}-\x{4FFFD}\x{50000}-\x{5FFFD}\x{60000}-\x{6FFFD}\x{70000}-\x{7FFFD}\x{80000}-\x{8FFFD}\x{90000}-\x{9FFFD}\x{A0000}-\x{AFFFD}\x{B0000}-\x{BFFFD}\x{C0000}-\x{CFFFD}\x{D0000}-\x{DFFFD}\x{E1000}-\x{EFFFD}!\$&'\(\)\*\+,;=:])*@)?(?:\[(?:(?:(?:[0-9a-f]{1,4}:){6}(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])(?:\.(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])){3})|::(?:[0-9a-f]{1,4}:){5}(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])(?:\.(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])){3})|(?:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){4}(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])(?:\.(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])){3})|(?:(?:[0-9a-f]{1,4}:){0,1}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){3}(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])(?:\.(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])){3})|(?:(?:[0-9a-f]{1,4}:){0,2}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){2}(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])(?:\.(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])){3})|(?:(?:[0-9a-f]{1,4}:){0,3}[0-9a-f]{1,4})?::[0-9a-f]{1,4}:(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])(?:\.(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])){3})|(?:(?:[0-9a-f]{1,4}:){0,4}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])(?:\.(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])){3})|(?:(?:[0-9a-f]{1,4}:){0,5}[0-9a-f]{1,4})?::[0-9a-f]{1,4}|(?:(?:[0-9a-f]{1,4}:){0,6}[0-9a-f]{1,4})?::)|v[0-9a-f]+\.[-a-z0-9\._~!\$&'\(\)\*\+,;=:]+)\]|(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])(?:\.(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])){3}|(?:%[0-9a-f][0-9a-f]|[-a-z0-9\._~\x{A0}-\x{D7FF}\x{F900}-\x{FDCF}\x{FDF0}-\x{FFEF}\x{10000}-\x{1FFFD}\x{20000}-\x{2FFFD}\x{30000}-\x{3FFFD}\x{40000}-\x{4FFFD}\x{50000}-\x{5FFFD}\x{60000}-\x{6FFFD}\x{70000}-\x{7FFFD}\x{80000}-\x{8FFFD}\x{90000}-\x{9FFFD}\x{A0000}-\x{AFFFD}\x{B0000}-\x{BFFFD}\x{C0000}-\x{CFFFD}\x{D0000}-\x{DFFFD}\x{E1000}-\x{EFFFD}!\$&'\(\)\*\+,;=])*)(?::[0-9]*)?(?:\/(?:(?:%[0-9a-f][0-9a-f]|[-a-z0-9\._~\x{A0}-\x{D7FF}\x{F900}-\x{FDCF}\x{FDF0}-\x{FFEF}\x{10000}-\x{1FFFD}\x{20000}-\x{2FFFD}\x{30000}-\x{3FFFD}\x{40000}-\x{4FFFD}\x{50000}-\x{5FFFD}\x{60000}-\x{6FFFD}\x{70000}-\x{7FFFD}\x{80000}-\x{8FFFD}\x{90000}-\x{9FFFD}\x{A0000}-\x{AFFFD}\x{B0000}-\x{BFFFD}\x{C0000}-\x{CFFFD}\x{D0000}-\x{DFFFD}\x{E1000}-\x{EFFFD}!\$&'\(\)\*\+,;=:@]))*)*|\/(?:(?:(?:(?:%[0-9a-f][0-9a-f]|[-a-z0-9\._~\x{A0}-\x{D7FF}\x{F900}-\x{FDCF}\x{FDF0}-\x{FFEF}\x{10000}-\x{1FFFD}\x{20000}-\x{2FFFD}\x{30000}-\x{3FFFD}\x{40000}-\x{4FFFD}\x{50000}-\x{5FFFD}\x{60000}-\x{6FFFD}\x{70000}-\x{7FFFD}\x{80000}-\x{8FFFD}\x{90000}-\x{9FFFD}\x{A0000}-\x{AFFFD}\x{B0000}-\x{BFFFD}\x{C0000}-\x{CFFFD}\x{D0000}-\x{DFFFD}\x{E1000}-\x{EFFFD}!\$&'\(\)\*\+,;=:@]))+)(?:\/(?:(?:%[0-9a-f][0-9a-f]|[-a-z0-9\._~\x{A0}-\x{D7FF}\x{F900}-\x{FDCF}\x{FDF0}-\x{FFEF}\x{10000}-\x{1FFFD}\x{20000}-\x{2FFFD}\x{30000}-\x{3FFFD}\x{40000}-\x{4FFFD}\x{50000}-\x{5FFFD}\x{60000}-\x{6FFFD}\x{70000}-\x{7FFFD}\x{80000}-\x{8FFFD}\x{90000}-\x{9FFFD}\x{A0000}-\x{AFFFD}\x{B0000}-\x{BFFFD}\x{C0000}-\x{CFFFD}\x{D0000}-\x{DFFFD}\x{E1000}-\x{EFFFD}!\$&'\(\)\*\+,;=:@]))*)*)?|(?:(?:(?:%[0-9a-f][0-9a-f]|[-a-z0-9\._~\x{A0}-\x{D7FF}\x{F900}-\x{FDCF}\x{FDF0}-\x{FFEF}\x{10000}-\x{1FFFD}\x{20000}-\x{2FFFD}\x{30000}-\x{3FFFD}\x{40000}-\x{4FFFD}\x{50000}-\x{5FFFD}\x{60000}-\x{6FFFD}\x{70000}-\x{7FFFD}\x{80000}-\x{8FFFD}\x{90000}-\x{9FFFD}\x{A0000}-\x{AFFFD}\x{B0000}-\x{BFFFD}\x{C0000}-\x{CFFFD}\x{D0000}-\x{DFFFD}\x{E1000}-\x{EFFFD}!\$&'\(\)\*\+,;=:@]))+)(?:\/(?:(?:%[0-9a-f][0-9a-f]|[-a-z0-9\._~\x{A0}-\x{D7FF}\x{F900}-\x{FDCF}\x{FDF0}-\x{FFEF}\x{10000}-\x{1FFFD}\x{20000}-\x{2FFFD}\x{30000}-\x{3FFFD}\x{40000}-\x{4FFFD}\x{50000}-\x{5FFFD}\x{60000}-\x{6FFFD}\x{70000}-\x{7FFFD}\x{80000}-\x{8FFFD}\x{90000}-\x{9FFFD}\x{A0000}-\x{AFFFD}\x{B0000}-\x{BFFFD}\x{C0000}-\x{CFFFD}\x{D0000}-\x{DFFFD}\x{E1000}-\x{EFFFD}!\$&'\(\)\*\+,;=:@]))*)*|(?!(?:%[0-9a-f][0-9a-f]|[-a-z0-9\._~\x{A0}-\x{D7FF}\x{F900}-\x{FDCF}\x{FDF0}-\x{FFEF}\x{10000}-\x{1FFFD}\x{20000}-\x{2FFFD}\x{30000}-\x{3FFFD}\x{40000}-\x{4FFFD}\x{50000}-\x{5FFFD}\x{60000}-\x{6FFFD}\x{70000}-\x{7FFFD}\x{80000}-\x{8FFFD}\x{90000}-\x{9FFFD}\x{A0000}-\x{AFFFD}\x{B0000}-\x{BFFFD}\x{C0000}-\x{CFFFD}\x{D0000}-\x{DFFFD}\x{E1000}-\x{EFFFD}!\$&'\(\)\*\+,;=:@])))(?:\?(?:(?:%[0-9a-f][0-9a-f]|[-a-z0-9\._~\x{A0}-\x{D7FF}\x{F900}-\x{FDCF}\x{FDF0}-\x{FFEF}\x{10000}-\x{1FFFD}\x{20000}-\x{2FFFD}\x{30000}-\x{3FFFD}\x{40000}-\x{4FFFD}\x{50000}-\x{5FFFD}\x{60000}-\x{6FFFD}\x{70000}-\x{7FFFD}\x{80000}-\x{8FFFD}\x{90000}-\x{9FFFD}\x{A0000}-\x{AFFFD}\x{B0000}-\x{BFFFD}\x{C0000}-\x{CFFFD}\x{D0000}-\x{DFFFD}\x{E1000}-\x{EFFFD}!\$&'\(\)\*\+,;=:@])|[\x{E000}-\x{F8FF}\x{F0000}-\x{FFFFD}\x{100000}-\x{10FFFD}\/\?])*)?(?:\#(?:(?:%[0-9a-f][0-9a-f]|[-a-z0-9\._~\x{A0}-\x{D7FF}\x{F900}-\x{FDCF}\x{FDF0}-\x{FFEF}\x{10000}-\x{1FFFD}\x{20000}-\x{2FFFD}\x{30000}-\x{3FFFD}\x{40000}-\x{4FFFD}\x{50000}-\x{5FFFD}\x{60000}-\x{6FFFD}\x{70000}-\x{7FFFD}\x{80000}-\x{8FFFD}\x{90000}-\x{9FFFD}\x{A0000}-\x{AFFFD}\x{B0000}-\x{BFFFD}\x{C0000}-\x{CFFFD}\x{D0000}-\x{DFFFD}\x{E1000}-\x{EFFFD}!\$&'\(\)\*\+,;=:@])|[\/\?])*)?$/i;

function regexIndexOf(text: string, re: RegExp, i: number) {
    var indexInSuffix = text.slice(i).search(re);
    return indexInSuffix < 0 ? indexInSuffix : indexInSuffix + i;
}

export function displayTextAreaField2(text: string | undefined): JSX.Element {
    // https://stackoverflow.com/questions/273789/is-there-a-version-of-javascripts-string-indexof-that-allows-for-regular-expr
    // https://stackoverflow.com/questions/161738/what-is-the-best-regular-expression-to-check-if-a-string-is-a-valid-url

    if (text === undefined)
    {
        return <div></div>
    }

    let ModifiedText: string = text;
    const ReplacementString: string = 'Pr0tOcoLr3plac3M3NtStrinG'
    
    let LinkIdx: number = regexIndexOf(ModifiedText, URLRegExp, 0);
    var MatchedURLLst = ModifiedText.match(URLRegExp);
    console.log(MatchedURLLst);

    return ( <div className='ColumnCenterSeriesDescription' dangerouslySetInnerHTML={{ __html: ModifiedText }}></div> )
}*/


export function displayTextAreaField(text: string | undefined): JSX.Element {
    if (text === undefined)
    {
        return <div></div>
    }

    let ModifiedText: string = convertLink(text, 'https://');
    ModifiedText = convertLink(ModifiedText, 'http://');

    return ( <div className='ColumnCenterSeriesDescription' dangerouslySetInnerHTML={{ __html: ModifiedText }}></div> )
}

function convertLink(text: string, protocol: string): string {
    let ModifiedText: string = text;
    const ReplacementString: string = 'Pr0tOcoLr3plac3M3NtStrinG'

    let LinkIdx: number = ModifiedText.indexOf(protocol);
    while(LinkIdx >= 0)
    {
        const EndOfLink: number = ModifiedText.indexOf(' ', LinkIdx);
        const LinkTxt: string = ModifiedText.substring(LinkIdx, EndOfLink);
        const LinkElementTxt: string = ' <a href=\'' + LinkTxt.replace(protocol, ReplacementString) + '\' target=\'_blank\' rel=\'noopener noreferrer\'>' + LinkTxt.replace(protocol, '') + '</a> ';

        ModifiedText = ModifiedText.replace(LinkTxt, LinkElementTxt);

        LinkIdx = ModifiedText.indexOf(protocol, LinkIdx + LinkElementTxt.length);
    }

    ModifiedText = ModifiedText.replaceAll(ReplacementString, protocol);

    return ModifiedText;
}

//return <a href={'https://desocialworld.com/u/' + ProfileUsername} target='_blank' rel="noopener noreferrer">@{ProfileUsername}</a>;

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Themes
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export function setProjectTheme(FrontendTheme: IFrontendTheme.IFrontendTheme, DefaultFrontendTheme: IFrontendTheme.IFrontendTheme | undefined)
{
    gConsoleLog('setProjectTheme invoked.');

    if (FrontendTheme.propertiesArr === undefined || FrontendTheme.propertiesArr === null)
    {
        setGenericTheme(DefaultFrontendTheme);
        return;
    }

    FrontendTheme.propertiesArr.forEach(item => document.documentElement.style.setProperty(item.name, item.value) );
}

export function setGenericTheme(DefaultFrontendTheme: IFrontendTheme.IFrontendTheme | undefined)
{
    if (DefaultFrontendTheme === undefined || DefaultFrontendTheme === null)
    {
        gConsoleLog('setGenericTheme - DefaultFrontendTheme undefined.');
        setOfflineFallbackTheme();
        return;
    }

    DefaultFrontendTheme.propertiesArr.forEach(item => document.documentElement.style.setProperty(item.name, item.value) );
}

export function setOfflineFallbackTheme()
{
  gConsoleLog('setOfflineFallbackTheme invoked.');

  /* background site-wide */
  document.documentElement.style.setProperty('--header-background-color', 'rgb(0, 0, 0)'); // NEEDED
  document.documentElement.style.setProperty('--landing-background-color', 'rgb(146, 146, 146)'); // NEEDED
  document.documentElement.style.setProperty('--left-menu-background-color', 'rgb(150, 66, 8, 0.8)');
  document.documentElement.style.setProperty('--right-column-background-color', 'rgb(150, 66, 8)');
  document.documentElement.style.setProperty('--app-background-color', 'rgb(182, 98, 40)');

  /* text site-wide */
  document.documentElement.style.setProperty('--header-text-color', 'rgb(255, 255, 255)'); // NEEDED
  document.documentElement.style.setProperty('--app-text-color', 'rgb(0, 0, 0)'); // NEEDED
  document.documentElement.style.setProperty('--app-link-text-color', 'rgb(97, 218, 251)'); // NEEDED

  /* nft-item-grid */
  document.documentElement.style.setProperty('--nft-item-grid-background-color', 'rgb(255, 255, 255)');

  /* LandingPageImageContainer */
  document.documentElement.style.setProperty('--landing-page-image-container-border-settings', '1px solid rgb(0, 0, 0)');
  document.documentElement.style.setProperty('--landing-page-image-container-background-color', 'rgba(255, 255, 255, 1)');

  /* traits table - standard */
  document.documentElement.style.setProperty('--traits-message-standard-background-color', 'rgb(86, 12, 0)');
  document.documentElement.style.setProperty('--traits-table-standard-border-settings', '1px solid rgb(108, 24, 0)');

  /* traits table - for mint merge */
  document.documentElement.style.setProperty('--traits-table-mint-merge-border-settings', '1px solid rgb(118, 34, 0)');

  /* mint pass table */
  document.documentElement.style.setProperty('--mintpass-table-standard-border-settings', '1px solid rgb(108, 24, 0)');

  /* info message */
  document.documentElement.style.setProperty('--info-message-success-background-color', 'rgb(53, 158, 30)');
  document.documentElement.style.setProperty('--info-message-failure-background-color', 'rgb(202, 42, 42)');

  /* LoggedInUserContainer */
  document.documentElement.style.setProperty('--logged-in-user-container-border-settings', '2px solid rgb(64, 64, 64)'); // NEEDED
  document.documentElement.style.setProperty('--logged-in-user-container-background-color', 'rgb(86, 86, 86)'); // NEEDED

  /* CustomButtonComponent */
  document.documentElement.style.setProperty('--custom-button-component-background-color', 'rgb(186, 186, 186)'); // NEEDED
  document.documentElement.style.setProperty('--custom-button-component-background-color-clicked', 'rgb(216, 216, 216)'); // NEEDED

  /* BusyIndicatorModal */
  document.documentElement.style.setProperty('--busy-indicator-modal-border-settings', '4px solid rgb(64, 64, 64)');
  document.documentElement.style.setProperty('--busy-indicator-modal-background-color', 'rgb(0, 0, 0)');

  /* modals */
  document.documentElement.style.setProperty('--modal-windows-background-color', 'rgb(182, 98, 40)');


  //document.documentElement.style.setProperty('', '');
}